import { Button, Form } from "react-bootstrap";
import { Modal, MuniSpinner2 } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import useActas from "../../../api/actas";
import { useState } from "react";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { format } from 'date-fns';


const ModalConstancia = ({ modals, handlerModal }) => {
    const fechaHoy = format(new Date(), 'yyyy-MM-dd');

    //? ESTADOS GLOBALES
    const { loads } = useGeneralAppStore();
    const { actaDetalle } = useActaDetalleStore();

    //TODO API
    const { cambiarEstadoDescargo, generarConstancia } = useActas();
    const [observacion, setObservacion] = useState("");
    const [fecha, setFecha] = useState(fechaHoy);

    const [pdf, setPdf] = useState();


    return (
        <>
            <Modal
                show={modals.includes('constancia')}
                size={"lg"}
                onHide={() => handlerModal({ modal: false, modalName: "constancia" })}
                title={() => "Constancia notificación digital"}
            >
                <div className="position-relative d-flex flex-column gap-4 justify-content-center align-items-center" style={{ minHeight: "100px" }}>
                    {
                        loads.includes('constancia') &&
                        <div className="position-absolute w-100 h-100 z-3 d-flex justify-content-center align-items-center" style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
                            <MuniSpinner2 />
                        </div>
                    }


                    <Button disabled={loads.includes("constancia") || pdf} className="w-100" size="lg" onClick={() => {
                        generarConstancia(actaDetalle.acta.id, setPdf)
                    }}>Generar constancia</Button>

                    {
                        pdf &&
                        <>
                            <a
                                href={pdf}
                                download={`Constancia notificación electrónica Acta ${actaDetalle?.acta.dependencia}-${actaDetalle?.acta.numero_acta}`}
                                className="text-center mb-3 px-1 d-block w-100"
                                style={{ border: "2px #1334c9 dashed" }}
                            >
                                DESCARGAR CONSTANCIA
                            </a>
                            <iframe src={pdf} height={"600px"} width={"100%"} />
                        </>

                    }
                </div>

            </Modal>
        </>
    );
}
export default ModalConstancia;